import { Box, Button, Container, createStyles, Text } from "@mantine/core";
import React, { useEffect, useState } from "react";
import Topbar from "../../../components/Topbar";

import "./style.css";
import CreateClaim from "../../../components/ClaimBilling/createClaim";
import PreviousClaims from "../../../components/ClaimBilling/previousClaims";

import { getInvoicesSetting } from "../../../services/invoicesetting";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CheckEligibilty from "../../../components/ClaimBilling/CheckEligibilty";
import { clearEligibilityData } from "../../../store/reducers/billing";
import DraftClaims from "../../../components/ClaimBilling/DraftClaims";

const useStyles = createStyles(() => ({
  mainbillingcontainer: {
    background: "#F5F5F5",
    // display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "fit-content",
    padding: "14px 28px 14px 20px",

    "@media (max-width:900px)": {
      paddingRight: "10px",
      paddingLeft: "10px",
    },
  },

    tabContainer: {
    display: "flex",
    minWidth: "260px",
    height: "40px",
    marginBottom:'20px'
  },
  activeTabBg: {
    background: "#fff !important",
    borderBottom: "3px solid #000",
    color: "#262626",
  },
  activeTab: {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    fontFamily: "Inter",
    padding: "5px 10px",
    cursor: "pointer",
    color: "#979797",
    "& p": {
      margin: "0",
      fontWeight: "600",
      color: "#979797",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },
  inActiveTab: {
    display: "flex",
    fontFamily: "Inter",
    alignItems: "center",
    background: "#fff",
    padding: "5px 10px",
    cursor: "pointer",
    color: "#979797",
    "& p": {
      color: "#979797",
      margin: "0",
      fontWeight: "600",
    },
    "& img": {
      width: "24px",
      marginRight: "5px",
    },
  },

  back: {
    marginTop: "21px",
    marginBottom: "27px",
    display: "flex",
    gap: "1px",
    cursor: "pointer",
    alignSelf: "flex-start",
  },

  textbox: {
    // marginTop: "26px",
    marginBottom: "19px",
    alignSelf: "flex-start",
    marginLeft: "20px",
  },

  flexbox: {
    display: "flex",
    justifyContent: "flex-end",
    width: "95%",
    position: "relative",
    bottom: "4%",
    cursor: "pointer",
  },
}));

const Billing = () => {
  const [open, setOpen] = useState(false);
  const { profile } = useSelector((state) => state?.profile);
  const [claimdetails, setClaimDetails] = useState(false);
  const [decryptedBillingData, setDecryptedBillingData] = useState(null);
  const [checkeligibility, setCheckEligibility] = useState(false);
  const [draftclaims, setDraftClaims] = useState(false);
  const [selectedTab, setSelectedTab] = useState(true);

  const dispatch = useDispatch();

  const handleClear = () => {
    dispatch(clearEligibilityData());
  };

  // console.log("checkeligibility", checkeligibility);

  const { classes } = useStyles();


    const handleTabChange = (tab) => {

      console.log('tab',tab);
      

      if (tab === false){
   setDraftClaims(true)
      }
else {
 setDraftClaims(false)
}

       
    setSelectedTab(tab);
 
  };


  const closemodal = () => {
    setOpen(false);
  };
  useEffect(() => {
    getInvoicesSetting();
  }, []);

  console.log("claimdetails", claimdetails);

  return (
    <Box fluid className="content">
      {/* <AlertModal isopen={open} close={() => setOpen(false)} /> */}
      <AppNavbar title="Billing" profile={profile} />
      {open ? (
        <div style={{ minHeight: "100vh" }} className="mainbillingcontainer">
          <div className="maincontainer">
            <div className="mainbillingbox">
              <img src="/assets/images/billingimg.png" alt="Icon" />
              <h1 className="terms">Terms and Agreement</h1>
              <p className="termspara">
                By signing up for Ogiso’s billing services you agree to our
                billing terms and agreement. Ogiso charges a 2% to 3% fee of the
                total billing amount.
              </p>
              <Button
                color="yellow"
                className="signupbillingbtn"
                padding={11}
                onClick={closemodal}
              >
                Signup for Billing
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <div
          style={{ flexDirection: "column" }}
          className="mainbillingcontainer"
        >
          {!claimdetails ? (
            <CreateClaim
              setCheckEligibility={setCheckEligibility}
              setDraftClaims={setDraftClaims}
            />
          ) : null}

          {!claimdetails ? (
            <Box className={classes.textbox}>
              {checkeligibility ? (
                <Box
                  // onClick={() => {
                  //   navigate("/home/billing");
                  // }}
                  onClick={() => {
                    setCheckEligibility(false);
                  }}
                  className={classes.back}
                >
                  <img
                    width={20}
                    src="/assets/images/chevron-backeleft.png"
                    alt="back-icon"
                  />
                  <Text ff="Inter" fz={12} fw={400} color="#262626">
                    Back
                  </Text>
                </Box>
              ) : null}




{!checkeligibility ? <>

    <Box className={classes.tabContainer}>
            <Box
              className={`${classes.activeTab} ${
                selectedTab ? classes.activeTabBg : ""
              }`}
              onClick={() => handleTabChange(true)}
            >
              <Text fw={500} ff={"Inter"}>
                Submitted
              </Text>
            </Box>
            <Box
              className={`${classes.inActiveTab} ${
                !selectedTab ? classes.activeTabBg : ""
              }`}
              onClick={() => handleTabChange(false)}
            >
              <Text fw={500} ff={"Inter"}>
                Draft
              </Text>
            </Box>
          </Box>


</>: null}

              <Text ff={"Inter"} fs={"16px"} fw={"700"} color={"#000"}>
                {checkeligibility
                  ? "Verify Eligibility Service"
                  : "Claims List"}
              </Text>

             
 


            </Box>
          ) : null}

          {checkeligibility ? (
            <>
              <Box className={classes.flexbox}>
                <Button
                  onClick={handleClear}
                  variant="fixed"
                  c={"#000"}
                  bg={"#F9FAFB"}
                  radius="md"
                  size="md"
                >
                  Clear
                </Button>
              </Box>
            </>
          ) : null}

          {claimdetails ? (
            <Box
              onClick={() => {
                // navigate("/home/billing");
                setClaimDetails(false);
                setDecryptedBillingData(null);
              }}
              className={classes.back}
            >
              <img
                width={20}
                src="/assets/images/chevron-backeleft.png"
                alt="back-icon"
              />
              <Text ff="Inter" fz={12} fw={400} color="#262626">
                Back
              </Text>
            </Box>
          ) : null}

          {!checkeligibility && !draftclaims ? (
            <PreviousClaims
              setClaimDetails={setClaimDetails}
              decryptedBillingData={decryptedBillingData}
              setDecryptedBillingData={setDecryptedBillingData}
            />
          ) : null}


            {draftclaims ? (
            <DraftClaims
              setClaimDetails={setClaimDetails}
              decryptedBillingData={decryptedBillingData}
              setDecryptedBillingData={setDecryptedBillingData}
            />
          ) : null}




          {checkeligibility ? <CheckEligibilty /> : null}
        </div>
      )}
    </Box>
  );
};

export default Billing;
